import React from 'react';
import { contactInfo } from '../data/mock';
import { Linkedin, Twitter, Facebook, Instagram, MapPin, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{ background: 'var(--bg-primary)', borderTop: '1px solid var(--border-subtle)', padding: '60px 7.6923% 30px' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '40px', marginBottom: '40px' }}>
          
          {/* 🔹 Company Branding & Parent Company Link */}
          <div>
            <Link to="/" aria-label="Ciqura Labs Home">
              <img 
                src="https://res.cloudinary.com/dlz8euavh/image/upload/c_crop,w_560,h_200/v1767175729/6-removebg-preview_rm41rl.png" 
                alt="Ciqura Labs Indore - Cybersecurity Training Division" 
                style={{ height: '70px', objectFit: 'contain', marginBottom: '16px', transform: 'scale(1.1)' }}
                loading="lazy"
              />
            </Link>
            <p className="body-medium" style={{ color: 'var(--text-secondary)', marginBottom: '12px' }}>
              <strong>Ciqura Labs</strong> is the specialized training arm of <strong>Ciqur24 LLP</strong>, providing industry-grade IT & Cybersecurity certifications in Indore.
            </p>
            <div style={{ display: 'flex', gap: '16px', marginTop: '20px' }}>
              <SocialIcon href={contactInfo.social.linkedin} icon={<Linkedin size={22} />} label="LinkedIn" />
              <SocialIcon href={contactInfo.social.facebook} icon={<Facebook size={22} />} label="Facebook" />
              <SocialIcon href={contactInfo.social.instagram} icon={<Instagram size={22} />} label="Instagram" />
              <SocialIcon href={contactInfo.social.twitter} icon={<Twitter size={22} />} label="Twitter" />
            </div>
          </div>

          {/* 🔹 Quick Navigation */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '20px', color: 'var(--brand-primary)' }}>Quick Links</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <FooterLink to="/about">About Ciqura Labs</FooterLink>
              <FooterLink to="/programs">All Training Programs</FooterLink>
              <FooterLink to="/internship">Bengaluru Internship</FooterLink>
              <FooterLink to="/contact">Contact Support</FooterLink>
            </ul>
          </div>

          {/* 🔹 Key Training Programs (Indore Targeted) */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '20px', color: 'var(--brand-primary)' }}>Our Programs</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <FooterLink to="/programs/cybersecurity">Ethical Hacking Indore</FooterLink>
              <FooterLink to="/programs/aiml">AI & Machine Learning</FooterLink>
              <FooterLink to="/programs/grc">GRC Professional</FooterLink>
              <FooterLink to="/programs/full-stack-development">Full Stack Web Dev</FooterLink>
              <FooterLink to="/programs/azure">Microsoft Azure Cloud</FooterLink>
            </ul>
          </div>

          {/* 🔹 Contact & Physical Office (Local SEO) */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '20px', color: 'var(--brand-primary)' }}>Visit Our Lab</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ display: 'flex', gap: '12px', marginBottom: '14px', alignItems: 'flex-start' }}>
                <MapPin size={20} style={{ color: 'var(--brand-primary)', flexShrink: 0, marginTop: '4px' }} />
                <address style={{ fontStyle: 'normal', color: 'var(--text-secondary)', fontSize: '14px', lineHeight: '1.5' }}>
                  113, First Floor, Shagun Arcade,<br />
                  Above Apna Sweets, Vijay Nagar,<br />
                  Indore, MP 452010
                </address>
              </li>
              <li style={{ display: 'flex', gap: '12px', marginBottom: '14px', alignItems: 'center' }}>
                <Phone size={18} style={{ color: 'var(--brand-primary)' }} />
                <a href={`tel:${contactInfo.phone}`} style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>{contactInfo.phone}</a>
              </li>
              <li style={{ display: 'flex', gap: '12px', marginBottom: '14px', alignItems: 'center' }}>
                <Mail size={18} style={{ color: 'var(--brand-primary)' }} />
                <a href={`mailto:${contactInfo.email}`} style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>{contactInfo.email}</a>
              </li>
            </ul>
          </div>
        </div>

        {/* 🔹 Copyright & Trust Signals */}
        <div style={{ borderTop: '1px solid var(--border-subtle)', paddingTop: '30px', textAlign: 'center' }}>
          <p className="body-medium" style={{ color: 'var(--text-muted)', fontSize: '13px' }}>
            © {new Date().getFullYear()} Ciqura Labs (Training Division of Ciqur24 LLP). <br />
            Registered as Ciqur24 LLP. Presence in Bengaluru, Gandhinagar, and Indore.
          </p>
        </div>
      </div>
    </footer>
  );
};

// Sub-components for cleaner code
const FooterLink = ({ to, children }) => (
  <li style={{ marginBottom: '12px' }}>
    <Link to={to} style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '15px', transition: 'all 0.2s' }} className="hover:text-brand-primary">
      {children}
    </Link>
  </li>
);

const SocialIcon = ({ href, icon, label }) => (
  <a href={href} aria-label={label} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-muted)', transition: 'color 0.3s ease' }} className="hover:text-brand-primary">
    {icon}
  </a>
);

export default Footer;